import * as Icon from "./component/Icons";
import { ROLES } from "../context/AuthContext";
import Dashboard from "./pages/Dashboard";
import CompanyProfile from "./pages/company/CompanyProfile";
import AddFund from "./pages/company/AddFund";
import FundRequests from "./pages/company/FundRequests";
import KycDocuments from "./pages/company/KycDocuments";
import BillerList from "./pages/billers&account/BillerList";
import AddCABulk from "./pages/billers&account/AddCABulk";
import AddCASingle from "./pages/billers&account/AddCASingle";
import SavedCA from "./pages/billers&account/SavedCA";
import Approval from "./pages/bill&payments/Approval";
import BillReview from "./pages/bill&payments/BillReview";
import DueDateCalendar from "./pages/bill&payments/DueDateCalendar";
import PaymentSuccess from "./pages/bill&payments/PaymentSuccess";
import Processing from "./pages/bill&payments/Processing";
import Notification from "./pages/communication/Notification";
import Support from "./pages/communication/Support";
import TransactionHistory from "./pages/records/TransactionHistory";
import Ledger from "./pages/records/Ledger";
import Reconciliation from "./pages/records/Reconciliation";
import Reports from "./pages/records/Reports";

// Single source of truth for the panel.
// Sidebar, routes and TopBar title/breadcrumb are all generated from this list.
// To add a new page: create it in ./pages and set `element` on its entry here.
// Entries without an `element` are not routed yet (link falls back to /dashboard).
// `roles` = roleIDs allowed to see/open the page (FleetOwner 3, Checker 9, Maker 10).
const ALL_ROLES = Object.values(ROLES);

export const panelMenu = [
  {
    group: "Overview",
    items: [
      {
        path: "/dashboard",
        roles: ALL_ROLES,
        label: "Dashboard",
        icon: Icon.DashboardIcon,
        element: Dashboard,
      },
    ],
  },
  {
    group: "Company",
    items: [
      {
        path: "/company-profile",
        roles: [ROLES.FLEET_OWNER],
        label: "Company profile",
        icon: Icon.ProfileIcon,
        element: CompanyProfile,
      },
      {
        path: "/kyc-documents",
        roles: [ROLES.FLEET_OWNER],
        label: "KYC documents",
        icon: Icon.ApprovalIcon,
        element: KycDocuments,
      },
      {
        path: "/company-add-fund",
        roles: [ROLES.FLEET_OWNER],
        label: "Add fund",
        icon: Icon.AddfundIcon,
        element: AddFund,
      },
      {
        path: "/fund-requests",
        roles: [ROLES.FLEET_OWNER],
        label: "Fund requests",
        icon: Icon.HistoryIcon,
        element: FundRequests,
      },
    ],
  },
  {
    group: "Billers & accounts",
    items: [
      {
        path: "/billers-accounts-list",
        roles: [ROLES.FLEET_OWNER, ROLES.MAKER],
        label: "Biller list",
        icon: Icon.BillersIcon,
        element: BillerList,
      },
      {
        path: "/add-ca-single",
        roles: [ROLES.FLEET_OWNER, ROLES.MAKER],
        label: "Add C/A — single",
        icon: Icon.CaSingleIcon,
        element: AddCASingle,
      },
      {
        path: "/add-ca-bulk",
        roles: [ROLES.FLEET_OWNER, ROLES.MAKER],
        label: "Add C/A — bulk",
        icon: Icon.CaBulkIcon,
        element: AddCABulk,
      },
      {
        path: "/saved-ca",
        roles: [ROLES.FLEET_OWNER, ROLES.MAKER],
        label: "Saved C/A",
        icon: Icon.SavedCaIcon,
        element: SavedCA,
      },
    ],
  },
  {
    group: "Bills & payments",
    items: [
      {
        path: "/due-date-calendar",
        roles: ALL_ROLES,
        label: "Due-date calendar",
        icon: Icon.CalendarIcon,
        element: DueDateCalendar,
      },
      {
        path: "/bill-review",
        roles: ALL_ROLES,
        label: "Bill review",
        icon: Icon.ReviewIcon,
        element: BillReview,
      },
      {
        path: "/approval",
        // Maker sees List/Detail and can withdraw own pending batch
        roles: ALL_ROLES,
        label: "Approval",
        icon: Icon.ApprovalIcon,
        element: Approval,
      },
      {
        path: "/processing",
        roles: ALL_ROLES,
        label: "Processing",
        icon: Icon.ProcessingIcon,
        element: Processing,
      },
      {
        path: "/payment-success",
        roles: ALL_ROLES,
        label: "Payment success",
        icon: Icon.SuccessIcon,
        element: PaymentSuccess,
      },
    ],
  },
  {
    group: "Records",
    items: [
      {
        path: "/transaction-history",
        roles: ALL_ROLES,
        label: "Transaction history",
        icon: Icon.HistoryIcon,
        element: TransactionHistory,
      },
      {
        path: "/ledger",
        roles: [ROLES.FLEET_OWNER, ROLES.CHECKER],
        label: "Ledger",
        icon: Icon.LedgerIcon,
        element: Ledger,
      },
      {
        path: "/reconciliation",
        roles: [ROLES.FLEET_OWNER, ROLES.CHECKER],
        label: "Reconciliation",
        icon: Icon.ReconIcon,
        element: Reconciliation,
      },
      {
        path: "/reports",
        roles: [ROLES.FLEET_OWNER, ROLES.CHECKER],
        label: "Reports",
        icon: Icon.ReportsIcon,
        element: Reports,
      },
    ],
  },
  {
    group: "Communication",
    items: [
      {
        path: "/notifications",
        roles: ALL_ROLES,
        label: "Notifications",
        icon: Icon.NotificationsIcon,
        element: Notification,
      },
      {
        path: "/support",
        roles: ALL_ROLES,
        label: "Support",
        icon: Icon.SupportIcon,
        element: Support,
      },
    ],
  },
];

// Flat list with group attached — used by App routes and TopBar
export const panelRoutes = panelMenu.flatMap((g) =>
  g.items.map((item) => ({ ...item, group: g.group })),
);

export const findRoute = (pathname) =>
  panelRoutes.find((r) => r.path === pathname);
